<!-- Header Structure -->
<template>
	<div>
		<v-toolbar
			class="Vuely-toolbar"
			app
			:color="activeHeaderFilter.class"
			fixed
		>
			<div class="d-custom-flex align-items-center navbar-left">
				<div class="site-logo-wrap d-custom-flex ml-0 align-items-center">
					<v-list-tile style="background: transparent !important;">
						<v-list-tile-content>
							<v-list-tile-sub-title>
								<a href="https://easymipres.com" target="_blank">
									<img src="/static/img/site-logo.png" alt="site logo" width="150">
								</a>
							</v-list-tile-sub-title>
<!--							<router-link :to="{name: activesMenus ? 'Dashboard' : 'Mipres'}" class="grayish-blue site-logo-img">-->
<!--								<img src="/static/img/site-logo.png" alt="site logo" width="150">-->
<!--							</router-link>-->
							<v-list-tile-sub-title class="body-2" v-if="getUser">{{getUser.empresa.razon_social}}</v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</div>
				<quick-links v-if="activesMenus"></quick-links>
			</div>
			<v-spacer></v-spacer>
			<div class="navbar-right pr-1">
				<v-btn icon large @click="toggleFullScreen" class="full-screen ma-0">
					<v-icon color="grey">fullscreen</v-icon>
				</v-btn>
				<!--<notifications></notifications>-->
			</div>
			<v-toolbar-items>
				<v-btn flat icon large @click.stop="$store.commit('showSettings', true)">
					<v-icon color="grey">settings</v-icon>
				</v-btn>
				<user></user>
			</v-toolbar-items>
		</v-toolbar>
	</div>
</template>

<script>
import appCustomizer from 'Components/Customizer/Customizer'
import screenfull from "screenfull";
import Notifications from "./Notifications";
import User from "./User";
import QuickLinks from "./QuickLinks";
import { mapGetters } from "vuex";

// eslint-disable-next-line
let deferredPrompt
window.addEventListener('beforeinstallprompt', (e) => {
	console.log('prueba', e)
	// Prevent Chrome 67 and earlier from automatically showing the prompt
	e.preventDefault()
	// Stash the event so it can be triggered later.
	deferredPrompt = e
	// eslint-disable-next-line
	btnAdd.style.display = 'block'
})

export default {
	props: {
		horizontal: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters([
			'activeHeaderFilter',
            'activesMenus',
			'getUser'
		])
	},
	methods: {
		// toggle full screen method
		toggleFullScreen() {
			if (screenfull.enabled) {
			screenfull.toggle();
			}
		}
	},
	components: {
		Notifications,
		QuickLinks,
		User,
		appCustomizer
	}
};
</script>
